// extracted by mini-css-extract-plugin
module.exports = {"timeInRoute":"timeInRoute-7jttr"};